import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { Modal, Button, Card } from 'antd';
import { CheckOutlined } from '@ant-design/icons';

import { BILLING_ENUMS, chargebeeBasicPlans, essentialsPlan } from '../constants';
import './billing.scss';

// This component is based off of the <PlanSelector> component. For spec details, see that component.
class BasicPlan extends Component {
  static propTypes = {
    changeModal: PropTypes.func.isRequired,
  };

  state = {
    open: true,
    selected: -1,
  }

  checkout = () => {
    const { selected } = this.state;
    const { changeModal } = this.props;
    const selectedPlan = chargebeeBasicPlans[selected];
    this.setState({ open: false });
    changeModal(BILLING_ENUMS.PROCESS_NEW_SUBSCRIPTION_PAYMENT, selectedPlan, true);
  }

  renderPlans = () => {
    return [essentialsPlan].map((plan, i) => {
      const {
        name,
        pricing,
        subtext,
        features,
      } = plan;
      return (
        <div className="plan-container" style={{ marginLeft: '25%' }}>
          <Card
            onClick={() => this.setState({ selected: i })}
            className={`plan-select${this.state.selected === i && 'ed'}`}
            bordered={false}
            style={{ borderRadius: '10px' }}
            bodyStyle={{ padding: '20px' }}
          >
            <div className="plan-header">
              <h3>{name}</h3>
              <h1>{pricing}</h1>
            </div>
            {
              subtext && (
                <div className="plan-subtext">
                  {subtext}
                </div>
              )
            }
            {
              features.map(feature => (
                <div className="plan-feature">
                  <CheckOutlined />
                  &nbsp;
                  {feature}
                </div>
              ))
            }
          </Card>
        </div>
      );
    });
  }

  render() {
    const { open, selected } = this.state;
    const { changeModal } = this.props;
    return (
      <Modal
        title={<div style={{ textAlign: 'center' }}>Our most basic plan</div>}
        bodyStyle={{ maxHeight: '70vh', overflowY: 'auto' }}
        footer={[
          <Button
            key="back"
            onClick={() => {
              return changeModal(BILLING_ENUMS.PLAN_SELECTOR, null, true);
            }}
          >
            Back
          </Button>,
          <Button
            key="subscribe"
            disabled={selected === -1}
            type="primary"
            onClick={this.checkout}
          >
            Subscribe
          </Button>,
        ]}
        visible={open}
        closable={false}
        maskClosable={false}
      >
        <div>
          As a testament to staying true to our roots of small solo practictioners, our ESSENTIALS plan includes the most basic features to
          get started with Medsender.
          <br />
          <br />
          We don&apos;t recommend it for most users, this plan only includes self-service support. EMR integration is also not included.
        </div>
        <div className="plan-selection-wrapper">
          {this.renderPlans()}
        </div>
      </Modal>
    );
  }
}

export default BasicPlan;
